import {
  mapDatesParams,
  mapFilterParams,
  mapLocationParams,
  mapMarketParams,
  mapPaginationParams,
  mapPaxesParams,
  mapSortByParams,
} from 'src/effects/Search/mappers'

export function buildSuggestedPropertiesPayload({
  excludedIDs,
  distance,
  reservationParams,
  filtersParams,
  offset,
  device,
  affiliate,
  source,
}) {
  const params = { ...reservationParams, ...filtersParams, offset }

  return {
    affiliate,
    source,
    excludedIDs,
    distance,
    device,
    ...mapDatesParams(params),
    ...mapLocationParams(params),
    ...mapMarketParams(params),
    ...mapPaxesParams(params),
    ...mapFilterParams(params),
    ...mapSortByParams(params),
    ...mapPaginationParams(params),
  }
}
